import BlogCarouselProps from "./BlogCarouselProps.interface";
import Card from "./components/Card/Card";
import Carousel from "./components/Carousel/Carousel";
import fetchBlogPosts from "./hooks/fetchBlogPosts";
import styles from "./BlogCarousel.module.scss";

import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import React, { FunctionComponent } from "react";
import useAnchor from "blocks/hooks/useAnchor";
import useBoxWrap from "blocks/hooks/useBoxWrap";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";

const BlogCarousel: FunctionComponent<BlogCarouselProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);
    const [boxWrapClasses, boxWrapStyles] = useBoxWrap(props.settings.cardBoxWrap);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    const { items, viewState } = fetchBlogPosts(props.content.tags);

    return (
        <section className={combineClasses(styles.wrapper, ...splitClasses, ...wrapperClasses, ...boxWrapClasses)} style={{ ...wrapperStyles, ...splitStyles, ...boxWrapStyles }} id={identifier}>
            {/* Loading */}
            {viewState === "LOADING" ? (
                <div className={styles.loading}></div>
            ) : null}

            {/* Loaded */}
            {viewState === "LOADED" && items && items.length > 0 ? (
                <Carousel>
                    {items.map((item: any, index: number) => {
                        return (
                            <Card key={index} {...item} imageCrop={props.settings.imageCrop} />
                        );
                    })}
                </Carousel>
            ) : null}

            {/* Empty */}
            {viewState === "EMPTY" ? (
                <div>Empty</div>
            ) : null}

            {/* Error */}
            {viewState === "ERROR" ? (
                <div>Error</div>
            ) : null}
        </section>
    );
};

export default BlogCarousel;
